module.exports = __webpack_public_path__ + "img/signature-img.34be1733.jpeg";